import { useContext } from "react"
import { ThemeContext } from "../Context/ThemeContext"
import { Switch } from "antd"


const SwitchTheme = () => {
    const [, setTheme] = useContext(ThemeContext)

    const changeTheme = (checked)=>{
        if (checked){
            setTheme("dark")
        }else if (!checked){
            setTheme("light")
        }
    }

    return(
        <>
            <Switch onChange={changeTheme} />
        </>
    )
}

export default SwitchTheme